let employees;

ready(() => {
	/**
	 * This functions fixes flex orphans that occures when you use justify-content: space-between
	 * It adds margins to the orphaned flex items
	 */
	let fixFlexOrphans = () => {
		let employees = document.querySelectorAll("#k-employees .employee__card");
		let nemployees = 4;

		employees.forEach((broker) => broker.removeAttribute("style"));
		if (window.innerWidth < 1024) return;

		if ( (employees.length % nemployees) === 2 ) {
			employees[employees.length - 1].style.marginLeft = "20px";
			employees[employees.length - 1].style.marginRight = "auto";
		} else if ( (employees.length % nemployees) === 3 ) {
			employees[employees.length - 2].style.marginLeft = "20px";
			employees[employees.length - 1].style.marginLeft = "20px";
			employees[employees.length - 1].style.marginRight = "auto";
		}

		return;
	};

	/**
	 * Create new List.js object
	 * @type {List}
	 */
	employees = new List("k-employees", {
		valueNames: [
			"employee__details__name",
			"employee__details__title",
			"employee__details__phone",
			"employee__details__email",
			"employee__details__department",
			{ name: "employee__details", attr: "data-meta-tags" }
		]
	});

	/**
	 * Fix flex orphans when list has been update
	 */
	employees.on("updated", () => {
		fixFlexOrphans();
	});

	employees.sort("employee__details__department", { order: "desc" })

	if ( window.location.hash.includes("#property:") ) {
		let propertyID = window.location.hash.split("#property:").pop();
		let estate = window.estates[propertyID];
		employees.search(estate)
		document.querySelector(".k-find-employee__search input").value = estate;
	}

	if ( window.location.hash.includes("#filter:") ) {
		let filter = decodeURIComponent(window.location.hash.split("#filter:").pop());
		employees.search(filter);
		document.querySelector(".k-find-employee__search input").value = filter;
	}

	window.addEventListener("resize", () => fixFlexOrphans());
	fixFlexOrphans();
})
